import React, { SyntheticEvent, useEffect, useState } from 'react'
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Stack,
    Typography,
    TextField,
    Paper,
    IconButton,
    Box,
    Tooltip,
    Grid,
    FormControl,
    MenuItem,
    Autocomplete
} from '@mui/material'
import { Icon } from '@iconify/react'
import MsiDatagrid from '../custom/MsiDatagridAuto'

import Tab from '@mui/material/Tab'
import TabList from '@mui/lab/TabList'
import TabPanel from '@mui/lab/TabPanel'
import TabContext from '@mui/lab/TabContext'

import axios from 'axios';
import apiUrl from '../../configs/constant';
import Swal from 'sweetalert2';
import DetailSO from './sales-order/DetailForm'

import { useNavigate } from "react-router-dom";
import { getDesigner, getDoctag } from '../../api/helper'
import { useToast } from '../ToastProvider'
import appInfo from '../../configs/app-info'

/* ===================== TYPES ===================== */
interface Props {
    open: boolean
    contact: any
    onClose: () => void
}

/* ===================== COMPONENT ===================== */

export default function DialogOrder({
    open,
    contact,
    onClose
}: Props) {
    const userData = JSON.parse(localStorage.getItem('user')!)
    const token = userData.token
    const cabang = JSON.parse(localStorage.getItem('cabang')!)

    const [tabs, setTabs] = useState<string>("0")
    const [listData, setListData] = useState<any[]>([])

    const [valDoctag, setValDoctag] = useState<any>(null)
    const [id, setId] = useState<any>(null)
    const [listDoctag, setListDoctag] = useState<any[]>([])

    const [openDialogAdd, setOpenDialogAdd] = useState<boolean>(false)

    const [mode, setMode] = useState<string>('')
    const [selectedId, setSelectedId] = useState<any>(null)

    const [kode, setKode] = useState('');
    const [designerId, setDesignerId] = useState(null);
    const [listDesigner, setListDesigner] = useState<any[]>([])
    const [valDesigner, setValDesigner] = useState<any>(null)

    const navigate = useNavigate();
    const { showToast, hideToast } = useToast();

    useEffect(() => {
        getData(tabs);
        fetchDesigner()
        fetchDoctag()
    }, [])

    const getData = (mode: any) => {
        let url = apiUrl.apiUrl + '/sales/sales-order/list'

        axios
            .get(url, {
                params: {
                    sdcust_id: contact?.sdcust_id,
                    mode: mode,
                },
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListData(data)
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })
    }

    const fetchDesigner = async () => {
        const response = await getDesigner(cabang, token);
        setListDesigner(response);
    };

    const fetchDoctag = async () => {
        const response = await getDoctag(appInfo.menuId.salesOrder, cabang, token);
        setListDoctag(response);
    };

    const handleChangeTabs = (event: SyntheticEvent, newValue: string) => {
        setTabs(newValue)
        getData(newValue)
    }

    const handleChangeAutocompleteDesigner = (event: SyntheticEvent, newValue: any | null) => {
        setDesignerId(newValue ? newValue.id : null)
        setValDesigner(newValue)
    }


    const handleDelete = (row: any) => {
        Swal.fire({
            title: 'Konfirmasi',
            text: 'Apakah anda ingin hapus data ini ?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#337ab7',
            cancelButtonColor: '#ffc107',
            confirmButtonText: 'Hapus'
        }).then(result => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: 'Now loading',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading()
                    }
                })

                const url = apiUrl.apiUrl + '/sales/sales-order/delete/' + row.id
                axios
                    .delete(url, {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    })
                    .then(response => {
                        if (response.data.success) {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                text: response.data.message,
                                icon: 'success',
                                timer: 1000,
                                timerProgressBar: true,
                                willClose: () => {
                                    getData(tabs)
                                }
                            })
                        } else {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                text: response.data.message,
                                icon: 'error'
                            })
                        }
                    })
                    .catch(error => {
                        Swal.fire({
                            title: 'Pemberitahuan',
                            text: error.message,
                            icon: 'error'
                        })
                    })
            }
        })
    };

    const ActionButtons = ({ row, onDelete, onNavigate }: {
        row: any;
        onDelete: (row: any) => void;
        onNavigate: (id: string) => void
    }) => {
        const actions = [
            {
                title: "Lihat Detail",
                icon: "mdi:search",
                color: "primary",
                onClick: () => onNavigate(row.id)
            },
            {
                title: "Print",
                icon: "mdi:printer",
                color: "primary",
                onClick: () => window.open(apiUrl.baseUrl + '/system/print/sdso/' + row.id, '_blank')
            },
            {
                title: "Hapus Sales Order",
                icon: "mdi:trash",
                color: "red",
                onClick: () => onDelete(row)
            }
        ];
        return (
            <Box sx={{ display: "flex", alignItems: "center" }}>
                {actions.map(action => (
                    <Tooltip key={action.title} title={action.title} placement="top">
                        <IconButton onClick={action.onClick}>
                            <Icon icon={action.icon} color={action.color} />
                        </IconButton>
                    </Tooltip>
                ))}
            </Box>
        );
    };
    const ActionButtonsOutstanding = ({ row, onDelete, onNavigate }: {
        row: any;
        onDelete: (row: any) => void;
        onNavigate: (id: string) => void
    }) => {
        return (
            <Box sx={{ display: "flex", alignItems: "center" }}>
                <Button
                    variant="contained"
                    color="success"
                    startIcon={<Icon icon="mdi:file-document-plus" />}
                    onClick={() => {
                        setId(row.id)
                        setValDoctag(null)
                        setOpenDialogAdd(true)
                    }}
                >
                    Buat Sales Order
                </Button>
            </Box>
        );
    };

    const actionData = [
        {
            key: "aksi",
            flex: 1,
            sortable: false,
            minWidth: 150,
            field: "aksi",
            align: "center",
            headerAlign: "center",
            headerName: "Aksi",
            renderCell: ({ row }: { row: any }) => (
                <ActionButtons
                    row={row}
                    onDelete={handleDelete}
                    onNavigate={(id) => {
                        setSelectedId(id)
                        setMode('detail')
                    }}
                />
            ),
        },
    ];

    const actionOutstanding = [
        {
            key: "aksi",
            flex: 1,
            sortable: false,
            minWidth: 100,
            field: "aksi",
            align: "center",
            headerAlign: "center",
            headerName: "Aksi",
            renderCell: ({ row }: { row: any }) => (
                <ActionButtonsOutstanding
                    row={row}
                    onDelete={handleDelete}
                    onNavigate={(id) => {
                        setSelectedId(id)
                        setMode('detail')
                    }}
                />
            ),
        },
    ];

    return (

        <>
            <Dialog open={open} onClose={onClose} fullWidth maxWidth={'xl'}>
                {/* <DialogTitle>Order</DialogTitle> */}
                <DialogTitle>
                    {mode === '' && 'Order'}
                    {mode === 'add' &&
                        <>
                            <IconButton
                                onClick={() => setMode('')}
                                sx={{ position: 'absolute', left: 10, top: 10 }}
                            >
                                <Icon icon="mdi:chevron-left-circle" />
                            </IconButton>
                            <Typography variant='h5' sx={{ textAlign: 'center' }}>

                                Add Order
                            </Typography>
                        </>
                    }
                    {mode === 'detail' &&
                        <>
                            <IconButton
                                onClick={() => setMode('')}
                                sx={{ position: 'absolute', left: 10, top: 10 }}
                            >
                                <Icon icon="mdi:chevron-left-circle" />
                            </IconButton>
                            <Box>
                                <Typography variant='h5' sx={{ textAlign: 'center' }}>
                                    Detail Sales Order
                                </Typography>
                                <Typography variant='body1' sx={{ textAlign: 'center' }}>
                                    No. Dokumen : <b>{selectedId}</b>
                                </Typography>
                            </Box>
                        </>
                    }

                    <IconButton
                        onClick={onClose}
                        sx={{ position: 'absolute', right: 10, top: 10 }}
                    >
                        <Icon icon="mdi:close" />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    {mode === '' && (
                        <TabContext value={tabs}>
                            <TabList
                                scrollButtons
                                variant='scrollable'
                                onChange={handleChangeTabs}
                                aria-label='forced scroll tabs example'
                            >
                                <Tab value='0' label='Daftar Sales Order' />
                                <Tab value='2' label='Outstanding Quotation' />
                            </TabList>
                            <TabPanel value='0'>
                                <MsiDatagrid array={listData} actions={actionData} hiddenColumns={['dokumen', 'sdcust_id', 'is_aktif', 'default_dp', 'default_dp_pesan']} />
                            </TabPanel>
                            <TabPanel value='2'>
                                <MsiDatagrid array={listData} actions={actionOutstanding} />
                            </TabPanel>
                        </TabContext>
                    )}

                    {mode === 'detail' && selectedId && (
                        <DetailSO
                            id={selectedId}
                            onClose={onClose}
                        />
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={onClose}>Close</Button>
                </DialogActions>
            </Dialog>

            <Dialog
                maxWidth={'sm'}
                fullWidth={true}
                open={openDialogAdd}
                onClose={() => setOpenDialogAdd(false)}
                aria-labelledby='form-dialog-title'
            >
                <DialogTitle id='form-dialog-title'>
                    <Typography variant='body1' sx={{ fontWeight: 500, mb: 1.5, color: '#212121' }}>
                        Buat Sales Order
                    </Typography>
                </DialogTitle>
                <DialogContent dividers sx={{ p: 2 }}>
                    <Grid container spacing={3} component="form" onSubmit={(e) => {
                        e.preventDefault();
                        // Handle form submission

                        const payload = {
                            id_quotation: id,
                            sysdoctag_id: valDoctag,
                            kode: kode,
                            designer_id: designerId
                        }
                        const url = apiUrl.apiUrl + '/sales/sales-order/add-so-from-quotation'
                        axios
                            .post(url, payload, {
                                headers: { Authorization: `Bearer ${token}` }
                            })
                            .then(response => {
                                if (response.data.success) {
                                    const data = response.data.data[0]

                                    showToast(response.data.message, 'success');
                                    setSelectedId(data.id)
                                    setMode('detail')
                                    // navigate('/sales/sales-order/detail/' + data.id)
                                } else {
                                    showToast(response.data.message, 'error');
                                }
                            })
                            .catch(error => {
                                showToast(error.message, 'error');
                            })
                    }}>
                        <Grid item xs={12}>
                            <FormControl fullWidth>
                                <TextField
                                    select
                                    label='Pilih Doctag'
                                    value={valDoctag}
                                    onChange={(e) => setValDoctag(e.target.value)}
                                >
                                    <MenuItem value="" disabled>Pilih Doctag</MenuItem>
                                    {listDoctag.map((item) => (
                                        <MenuItem key={item.id} value={item.id}>
                                            {item.nama}
                                        </MenuItem>
                                    ))}
                                </TextField>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                label="Kode"
                                fullWidth
                                value={kode}
                                onChange={(e) => setKode(e.target.value)}
                                placeholder="Masukkan kode"
                            />
                        </Grid>
                        <Grid item xs={12} md={12}>
                            <FormControl fullWidth>
                                <Autocomplete
                                    value={valDesigner}
                                    options={listDesigner}
                                    id='designer_id'
                                    isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                                    onChange={handleChangeAutocompleteDesigner}
                                    getOptionLabel={(option: any) => option?.nama || ""}   // ?? penting
                                    renderOption={(props: any, option: any) => {
                                        return (
                                            <li {...props} key={option.id}>
                                                {option.nama}
                                            </li>
                                        )
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            required
                                            label='Designer'
                                            InputLabelProps={{ shrink: true }}
                                        />
                                    )}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                            <Button
                                variant='contained'
                                type='submit'
                                disabled={!valDoctag || !kode || !designerId}
                                fullWidth
                            >
                                Buat SO
                            </Button>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions className='dialog-actions-dense'>
                    <Button onClick={() => setOpenDialogAdd(false)}>Batal</Button>
                </DialogActions>
            </Dialog>
        </>
    )
}